import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import {
  getMainProductInfo,
  MainProductInfoSchema,
} from "src/models/newProduct/getMainProductInfo";

export const useGetMainProductInfo = () => {
  const [mainProductInfo, setMainProductInfo] =
    useState<MainProductInfoSchema[]>();
  const [isLoadingProductInfo, setLoadingProductInfo] = useState<boolean>();
  const [error, setError] = useState(false);

  const router = useRouter();
  const citySlug = router.query.city;
  const productSlug = router.query.product;

  useEffect(() => {
    setLoadingProductInfo(true);
    if (typeof citySlug === "string" && typeof productSlug === "string") {
      getMainProductInfo({
        product_slug: productSlug,
        city_slug: citySlug,
      })
        .then((res) => setMainProductInfo(res.data))
        .catch(() => setError(true))
        .finally(() => setLoadingProductInfo(false));
    }
  }, [citySlug, productSlug]);

  return { mainProductInfo, isLoadingProductInfo, error };
};
